<ng-container *transloco="let convert;">

  <div class="container" (window:resize)="onResize()">
    @if (isMobile && isSharedList) {
      <div class="shared-lists-filters-mobile border border-dark wrapper">
        <div id="mobile-filters-buttons">
          @if (showMobileFiltersBtn) {
            <button data-testid="common-list-mobile-filters-show-button" id="filter-button" class="btn btn-link text-primary"
              (click)="showMobileFilters()">
              <i aria-hidden="true" class="me-1 allycon-filter"></i>
              {{ convert('vehicles.sharedLists.btnFilters') }}
            </button>
          }
          @if (showCloseMobileFiltersBtn) {
            <button data-testid="common-list-mobile-filters-close-button" class="btn btn-link text-primary" id="filter-button"
              (click)="hideMobileFilters()">
              <i class="me-1 allycon-glyph-chevron-left" aria-hidden="true"></i>
              {{ convert('vehicles.bidListFilter.btnCloseFilters') }}
            </button>
          }
        </div>
        <div>
          @if (mobileFilters) {
            <div class="filters-mobile">
              <label class="mobile-labels">{{ convert('vehicles.sharedLists.labelSharedByFilter') }}</label>
              <div class="shared-list__select-mobile">
                <trap-focus [enableFocusTrap]="sharedByDropdownFocusTrap" [enableArrowKeys]="true">
                  <app-dropdown-select data-testid="common-list-mobile-filters-shared-by-select" class="shared-lists-name" label="Shared By" [items]="sharedList" [analyticsListItemName]="'Seller Name'"
                    (click)="sharedBySelection($event.target)" (openChange)="onSharedByOpenChange($event)">
                  </app-dropdown-select>
                </trap-focus>
              </div>
            </div>
          }
          @if (mobileFilters) {
            <div class="filters-mobile"
              [ngClass]="userUuid === 'ALL' ? ' d-none flex-column align-items-center' : 'd-flex flex-column align-items-center'">
              <label class="list-name-mobile-filter">{{ convert('vehicles.sharedLists.labelListNameFilter') }}</label>
              <div class="shared-list__select">
                <trap-focus [enableFocusTrap]="listNameDropdownFocusTrap" [enableArrowKeys]="true">
                  <app-dropdown-select data-testid="common-list-mobile-filters-list-name-select" class="shared-lists-name" label="List Name" [items]="offerLists" [analyticsListItemName]="'List Name'"
                    (click)="listNameSelection($event.target)" (openChange)="onListNameOpenChange($event)">
                  </app-dropdown-select>
                </trap-focus>
              </div>
            </div>
          }
          @if (mobileFilters) {
            <div class="sort-by-filter ms-auto d-flex flex-column align-items-left">
              <label class="sort-by-mobile-label">{{ convert('vehicles.sharedLists.labelSortByFilter') }}</label>
              @if (bidList$ | async; as bidlist) {
                <div>
                  <app-bidlist-sort-select data-testid="common-list-mobile-filters-sort-select" class="sort-by-mobile" [selection]="sortValue"
                    [disabledFlag]="bidlist.items && bidlist.items.length === 0">
                  </app-bidlist-sort-select>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    @if (isSharedList && !isMobile) {
      <div class="shared-lists-filters border border-dark wrapper">
        <div class="row ms-0 me-0">
          <div class="ms-4 d-flex flex-row align-items-center">
            <label class="shared-list__label">{{translatedObject[1]?.SharedByFilterLabel}}
            </label>
            <div class="shared-list__select">
              <trap-focus [enableFocusTrap]="sharedByDropdownFocusTrap" [enableArrowKeys]="true"
                [focusOnFirstElem]="true">
                <app-dropdown-select data-testid="common-list-desktop-filters-shared-by-select" class="shared-lists-name" label="Shared By" [items]="sharedList" [analyticsListItemName]="'Seller Name'"
                  (click)="sharedBySelection($event.target)" (openChange)="onSharedByOpenChange($event)">
                </app-dropdown-select>
              </trap-focus>
            </div>
          </div>
          <div
            [ngClass]="userUuid === 'ALL' ? 'ms-4 d-none flex-row align-items-center' : 'ms-4 d-flex flex-row align-items-center'">
            <label class="shared-list__label">{{translatedObject[1]?.labelListName}}</label>
            <div class="shared-list__select">
              <trap-focus [enableFocusTrap]="listNameDropdownFocusTrap" [enableArrowKeys]="true">
                <app-dropdown-select data-testid="common-list-desktop-filters-list-name-select" class="shared-lists-name" label="List Name" [items]="offerLists" [analyticsListItemName]="'List Name'"
                  (click)="listNameSelection($event.target)" (openChange)="onListNameOpenChange($event)">
                </app-dropdown-select>
              </trap-focus>
            </div>
          </div>
          <div class="ms-auto d-flex flex-row align-items-center">
            @if (bidList$ | async; as bidlist) {
              <div class="bidlist-filters__select">
                <app-bidlist-sort-select data-testid="common-list-desktop-filters-sort-select" id="select-sort-by" label="{{ convert('vehicles.bidListFilter.labelSortBy') }}"
                  [selection]="sortValue" [disabledFlag]="bidlist.items && bidlist.items.length === 0">
                  <label for="select-sort-by" class="app-label border border-danger">{{
                  convert('vehicles.bidListFilter.labelSortBy') }}</label>
                </app-bidlist-sort-select>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <div class="container">

    @if (bidList$ | async; as bidlist) {
      @if (bidlist.pagination.loadingState == 'success' && !isSharedList) {
        <bidlist-filters data-testid="common-list-filters-container" [bidlist]="bidlist"></bidlist-filters>
      }
      <div class="banner-wrapper">
        @if (multiOfferActionSuccess) {
          <app-common-banner data-testid="common-list-banner-offer-success" (close)="closeSuccessBanner()"
          [bannerConfig]="multiOfferActionSuccess"></app-common-banner>
        }
        @for (errorBanner of multiOfferActionErrors; track errorBanner; let index = $index) {
          <app-common-banner
          [attr.data-testid]="'common-list-banner-offer-error-' + $index" (close)="closeErrorBanner(index)" [bannerConfig]="errorBanner"></app-common-banner>
        }
        @if (bidListMultiRemoveSuccess) {
          <app-common-banner data-testid="common-list-banner-remove-success" (close)="closeBidListMultiRemoveSuccess()"
          [bannerConfig]="bidListMultiRemoveSuccess"></app-common-banner>
        }
        @for (errorBanner of bidListMultiRemoveError; track errorBanner; let index = $index) {
          <app-common-banner
          [attr.data-testid]="'common-list-banner-remove-error-' + $index" (close)="closeBidListMultiRemoveError(index)" [bannerConfig]="errorBanner"></app-common-banner>
        }
      </div>
      @if (isSharedList) {
        <div class="search-results-count-container">
          <div data-testid="common-list-results-count" id="search_results_count">
            {{ vehicleListCount }} {{translatedObject[1]?.vehicleLabel}}
          </div>
          <div class="search-results-divider"></div>
        </div>
      }
      @switch (bidlist.pagination.loadingState) {
        @case ('loading') {
          <ul data-testid="common-list-results-loader" [attr.aria-label]="convert('vehicles.bidList.ariaLabelLoading')">
            @for (shell of loaderShells; track shell) {
              <li class="bidList__list">
                <ng-container *ngTemplateOutlet="loader"></ng-container>
              </li>
            }
          </ul>
        }
        @case ('error') {
          <div class="row">
            <div class="col-12">
              <app-error-message data-testid="common-list-results-error-message" title="{{ convert('vehicles.bidList.titleRequest') }}"
              subtitle="{{ convert('vehicles.bidList.subTitleLater') }}"></app-error-message>
            </div>
          </div>
        }
        @case ('success') {
          <div class="list-display-controls" [ngStyle]="alignCtaBtns()">
            @if (multiVehicleRemovalEnabled && !isSharedList && !isMobile) {
              <div class="bid-list-multi-remove">
                <div class="bid-list-checkbox-controls">
                  @if (bidListMultiSelectEnabled) {
                    <div class="custom-control custom-checkbox me-2">
                      <input data-testid="common-list-controls-select-all-checkbox" type="checkbox" class="custom-control-input" id="select-all-bid-list"
                        [attr.aria-label]="convert('vehicles.bidList.ariaLabelSelectAllVehiclesCheckbox')"
                        (click)="handleSelectAllBidListVehiclesClick($event)" [checked]="isSelectAllChecked" />
                      <label for="select-all-bid-list" class="custom-control-label"></label>
                    </div>
                  }
                  <button class="btn btn-outline-primary"
                    data-test-id="app-common-list-e-select-all-mobile-button" data-testid="common-list-controls-select-all-button"
                    [attr.allytmln]=bidListSelectAllButtonAnalytics
                    (click)="toggleBidListMultiSelect()">
                    {{ convert(bidListSelectAllButtonText) }}
                  </button>
                </div>
                @if (bidListMultiSelectEnabled) {
                  <span data-test-id="app-common-list-e-bid-list-remove-note-text" data-testid="common-list-controls-remove-note-text">
                    <strong>{{ convert('common.note') }}</strong>
                    {{ convert('vehicles.bidList.textBidListMultiRemoveLimitDescription') }}
                  </span>
                }
              </div>
            }
            @if (!inServiceOrCustomOffersListEnabled) {
              <div class="shared-list-select-all-note">
                @if (offerListName !== 'All') {
                  <span>
                    <strong>{{convert('common.note')}}</strong>
                    {{convert('vehicles.sharedLists.textMultiPurchaseNote')}}
                  </span>
                }
              </div>
            }
            <div class="collapse-state">
              @if (!isListView) {
                <button data-testid="common-list-controls-collapse-button" data-track-elem="icon" data-track-name="collapse all"
                  class="btn text-primary collapse-expand"
                  [attr.aria-label]="convert('vehicles.bidList.ariaLabelCollapse')"
                  (click)="toggleCollapseState(true)" [attr.aria-expanded]="!allCollapsed">
                  <img src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-collapse.svg"
                    alt="{{ convert('vehicles.bidList.ariaLabelCollapse') }}" />
                  {{ convert('vehicles.bidList.labelCollapseAll') }}
                </button>
              }
              @if (!isListView) {
                <button data-testid="common-list-controls-expand-button" data-track-elem="icon" data-track-name="expand all"
                  class="btn text-primary collapse-expand" [attr.aria-label]="convert('vehicles.bidList.ariaLabelExpand')"
                  (click)="toggleCollapseState(false)" [attr.aria-expanded]="!allCollapsed">
                  <img src="/ui/assets/assets-{{ tenantName }}/{{ tenantName }}-expand.svg"
                    alt="{{ convert('vehicles.bidList.ariaLabelExpand') }}" />
                  {{ convert('vehicles.bidList.labelExpandAll') }}
                </button>
              }
              <button data-testid="common-list-controls-card-view-button" data-track-elem="icon" data-track-name="card-view" class="btn view-btn"
                (click)="toggleView('CARD')" [disabled]="!isListView">
                @if (isListView) {
                  <img src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-card-view.svg"
                    alt="card view icon" />
                }
                @if (!isListView) {
                  <img src="assets/icons/card-view-active.svg" alt="card view icon" />
                }
                {{ convert('common.cardView') }}
              </button>
              <button data-testid="common-list-controls-list-view-button" data-track-elem="icon" data-track-name="list-view" class="btn view-btn"
                (click)="toggleView('LIST')" [disabled]="isListView">
                @if (!isListView) {
                  <img src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-list-view.svg"
                    alt="list view icon" />
                }
                @if (isListView) {
                  <img src="assets/icons/list-view-active.svg" alt="list view icon" />
                }
                {{ convert('common.listView') }}
              </button>
            </div>
            @if (multiVehicleRemovalEnabled && !isSharedList && isMobile) {
              <div class="bid-list-checkbox-controls bid-list-select-all-mobile">
                @if (bidListMultiSelectEnabled) {
                  <div class="custom-control custom-checkbox spacing me-2">
                    <input data-testid="common-list-controls-select-all-mobile-checkbox" type="checkbox" class="custom-control-input" id="select-all-bid-list-mobile"
                      [attr.aria-label]="convert('vehicles.bidList.ariaLabelSelectAllVehiclesCheckbox')"
                      (click)="handleSelectAllBidListVehiclesClick($event)" [checked]="isSelectAllChecked" />
                    <label for="select-all-bid-list-mobile" class="custom-control-label"></label>
                  </div>
                }
                <button class="btn btn-outline-primary bid-list-select-all-mobile"
                  data-test-id="app-common-list-e-select-all-button" data-testid="common-list-controls-select-all-mobile-button"
                  (click)="toggleBidListMultiSelect()">
                  {{ convert(bidListSelectAllButtonText) }}
                </button>
              </div>
            }
          </div>
          @if (multiVehicleRemovalEnabled && !isSharedList && isMobile) {
            @if (bidListMultiSelectEnabled) {
              <span data-test-id="app-common-list-e-bid-list-remove-note-text" data-testid="common-list-controls-remove-note-mobile-text">
                <strong>{{ convert('common.note') }}</strong>
                {{ convert('vehicles.bidList.textBidListMultiRemoveLimitDescription') }}
              </span>
            }
          }
          <div class="shared-list-checkbox-controls">
            @if (offerListName !== 'All' && isOfferListBuyerSelectAllEnabled) {
              <div class="custom-control custom-checkbox spacing">
                <input data-testid="common-list-controls-shared-select-all-checkbox" type="checkbox" class="custom-control-input" id="select-all-shared-list"
                  [attr.aria-label]="convert('vehicles.sharedLists.ariaLabelSelectAllVehiclesCheckbox')"
                  (click)="handleSelectAllSharedListVehiclesClick($event)" [checked]="isSelectAllChecked" />
                <label for="select-all-shared-list" class="custom-control-label">
                  <span>{{convert('vehicles.sharedLists.labelSelectAllVehiclesCheckbox')}}</span>
                </label>
              </div>
            }
          </div>
          @if (bidlist.items && bidlist.items.length > 0) {
            @if (!isListView || isMobile) {
              <ng-template #vehicleCardTpl let-item let-i="index">
                <sw-vehicle-container-hook [vehicleData]="item" [isVdpRefactorEnabled]="isVdpRefactorEnabled">
                  @if (!isSharedList && !isListView) {
                    <bidlist-inventory-item
                      [isListView]="isListView" [currentPage]="bidlist.pagination.page" [bidlistMultiRemoveLimit]="BIDLIST_MULTI_REMOVE_LIMIT"
                      [bidItem]="item" variant="result" [dealershipCollection]="dealershipCollectionWithProfile"
                      [dealershipFinanceMap]="dealershipFinanceMap" [buyerTipEnabled]="buyerTipEnabled"
                      [userPreferences]="userProfile?.userPreferences" [financeSources]="financeSources"
                      [tenantName]="tenantName" [urlBase]="urlBase" [urlBaseExternal]="urlBaseExternal"
                      (removeItem)="remove(item.auctionItemUuid)" (readdItem)="undo(item.auctionItemUuid)"
                      (onReviewSelectAllNeeded)="evaluateSelectAllCheckbox()"
                      (onItemUpdate)="refreshTime()" [index]="i"
                      [isSharedListVehicleSelected]="isSharedListVehicleToggled(item.auctionItemUuid)" [paginatedSharedList$]="bidList$"
                      [isBidListVehicleSelected]="isBidListVehicleToggled(item.auctionItemUuid)" [paginatedBidList$]="bidList$"
                      [isVehicleSelected]="isVehicleToggled(item.auctionItemUuid)"
                      [bidListMultiSelectEnabled]="bidListMultiSelectEnabled"
                      [bidlistInventoryItemTranslations]="bidlistInventoryItemTranslations"
                      [platformSpareKeyFee]="bidlist.pagination.metaData?.platformSpareKeyFee"
                      [hide]="hasBeenRemoved(item.auctionItemUuid)"
                    (bidItemUpdated)="bidlist.items[i]= $event"></bidlist-inventory-item>
                  }
                  @if (isSharedList && !isListView) {
                    <bidlist-inventory-item [isListView]="isListView" [currentPage]="bidlist.pagination.page" [bidlistMultiRemoveLimit]="BIDLIST_MULTI_REMOVE_LIMIT"
                      [bidItem]="item" variant="result" [dealershipCollection]="dealershipCollectionWithProfile"
                      [dealershipFinanceMap]="dealershipFinanceMap" [buyerTipEnabled]="buyerTipEnabled"
                      [userPreferences]="userProfile?.userPreferences" [financeSources]="financeSources"
                      [tenantName]="tenantName" [urlBase]="urlBase" [urlBaseExternal]="urlBaseExternal" [index]="i"
                      [isSharedListVehicleSelected]="isSharedListVehicleToggled(item.auctionItemUuid)" [paginatedSharedList$]="bidList$"
                      [isBidListVehicleSelected]="isBidListVehicleToggled(item.auctionItemUuid)" [paginatedBidList$]="bidList$"
                      [isVehicleSelected]="isVehicleToggled(item.auctionItemUuid)"
                      [bidListMultiSelectEnabled]="bidListMultiSelectEnabled"
                      [bidlistInventoryItemTranslations]="bidlistInventoryItemTranslations"
                      [platformSpareKeyFee]="bidlist.pagination.metaData?.platformSpareKeyFee"
                      (onReviewSelectAllNeeded)="evaluateSelectAllCheckbox()"
                    (bidItemUpdated)="bidlist.items[i]= $event"></bidlist-inventory-item>
                  }
                  @if (isListView && isMobile) {
                    <bidlist-inventory-item
                      [isListView]="isListView" [currentPage]="bidlist.pagination.page" [bidlistMultiRemoveLimit]="BIDLIST_MULTI_REMOVE_LIMIT"
                      [bidItem]="item" variant="result" [dealershipCollection]="dealershipCollectionWithProfile"
                      [dealershipFinanceMap]="dealershipFinanceMap" [buyerTipEnabled]="buyerTipEnabled"
                      [userPreferences]="userProfile?.userPreferences" [financeSources]="financeSources"
                      [tenantName]="tenantName" [urlBase]="urlBase" [urlBaseExternal]="urlBaseExternal" [index]="i"
                      [isSharedListVehicleSelected]="isSharedListVehicleToggled(item.auctionItemUuid)" [paginatedSharedList$]="bidList$"
                      [isBidListVehicleSelected]="isBidListVehicleToggled(item.auctionItemUuid)" [paginatedBidList$]="bidList$"
                      [isVehicleSelected]="isVehicleToggled(item.auctionItemUuid)"
                      [bidListMultiSelectEnabled]="bidListMultiSelectEnabled"
                      [bidlistInventoryItemTranslations]="bidlistInventoryItemTranslations"
                      [platformSpareKeyFee]="bidlist.pagination.metaData?.platformSpareKeyFee"
                      (onReviewSelectAllNeeded)="evaluateSelectAllCheckbox()"
                      (bidItemUpdated)="bidlist.items[i]= $event"
                    [hide]="hasBeenRemoved(item.auctionItemUuid)"></bidlist-inventory-item>
                  }
                </sw-vehicle-container-hook>
              </ng-template>

              @if (virtualScrollEnabled) {
                <cdk-virtual-scroll-viewport #commonList scrollWindow>
                  <ul>
                    <!-- templateCacheSize: 0 turns off CDK's view recycling. This is required, not
                         tuned. bidlist-inventory-item seeds its state in ngOnInit, and CDK does not
                         re-run ngOnInit on a recycled view, so the card would show the previous
                         vehicle's state. -->
                    <li *cdkVirtualFor="let item of bidlist.items; let i = index; trackBy: trackById; templateCacheSize: 0"
                        [attr.data-testid]="'common-list-results-item-' + i"
                        class="bidList__list"
                        virtualItemMeasure [virtualItemMeasureKey]="item.inventoryItemUuid">
                      <ng-container
                        [ngTemplateOutlet]="vehicleCardTpl"
                        [ngTemplateOutletContext]="{ $implicit: item, index: i }">
                      </ng-container>
                    </li>
                  </ul>
                </cdk-virtual-scroll-viewport>
              } @else {
                <ul #commonList>
                  @for (item of bidlist.items; track trackById(i, item); let i = $index) {
                    <li [attr.data-testid]="'common-list-results-item-' + $index" class="bidList__list">
                      <ng-container
                        [ngTemplateOutlet]="vehicleCardTpl"
                        [ngTemplateOutletContext]="{ $implicit: item, index: i }">
                      </ng-container>
                    </li>
                  }
                </ul>
              }
            }
            @if (isListView && !isMobile) {
              <table data-testid="common-list-results-table" #listTable aria-label="List View Table" class="listViewTable">
                <thead data-testid="common-list-results-table-header" class="list-view-headers fw-bold">
                  <tr data-testid="common-list-results-header-row">
                    @if (showCheckboxColumnForListView) {
                      <th id="Selected"></th>
                    }
                    <th data-testid="common-list-results-header-vin" id="Vin">{{ convert('vehicles.sharedListsListView.headerVin') }}</th>
                    @if(isSharedList && isInspectionSeriesEnabled) {
                      <th data-testid="common-list-results-header-inspection-series" class="text-uppercase">{{ bidlistInventoryItemTranslations.inspectionSeries }}</th>
                    }
                    <th data-testid="common-list-results-header-vehicle" id="Vehicle">{{ convert('vehicles.sharedListsListView.headerVehicle') }}</th>
                    <th data-testid="common-list-results-header-color" id="Color">{{ convert('common.color').toUpperCase() }}</th>
                    <th data-testid="common-list-results-header-odometer" id="Odometer">{{ convert('vehicles.sharedListsListView.headerOdometer') }} ({{
                    convert('common.distanceUnit').toUpperCase()}})</th>
                    @if (isSharedList) {
                      <th data-testid="common-list-results-header-seller-offer" id="SellerOffer">{{ convert('vehicles.sharedListsListView.headerSellerOffer')
                      }}</th>
                    }
                    @if (!isSharedList) {
                      <th data-testid="common-list-results-header-opening-price" id="OpeningPrice">{{ convert('vehicles.sharedListsListView.headerOpeningPrice') }}/ {{
                      convert('vehicles.sharedListsListView.headerCurrentPrice')}}</th>
                    }
                    <th data-testid="common-list-results-header-fees" id="Fees">{{ convert('vehicles.sharedListsListView.headerFees') }}</th>
                    @if (isSharedList) {
                      <th data-testid="common-list-results-header-total-purchase-price" id="TotalPurchasePrice">{{
                      convert('vehicles.sharedListsListView.headerTotalPurchasePrice') }}</th>
                    }
                    @if (showDelivery) {
                      <th data-testid="common-list-results-header-delivery" id="Delivery">{{ convert('vehicles.sharedListsListView.headerDelivery') }}
                      </th>
                    }
                    @if (showShippingQuote) {
                      <th data-testid="common-list-results-header-shipping" id="Shipping">{{ convert('vehicles.sharedListsListView.headerShipping')
                      }}</th>
                    }
                    <th data-testid="common-list-results-header-credit-line" id="Credit Line">{{ convert('vehicles.sharedListsListView.headerCreditLine') }}</th>
                    <th data-testid="common-list-results-header-status" id="Status">{{ convert('vehicles.sharedListsListView.headerStatus') }}</th>
                    <th data-testid="common-list-results-header-actions" id="Accept/Counter/Decline Tooltip" aria-hidden="true"></th>
                  </tr>
                </thead>
                @for (item of bidlist.items; track trackById(i, item); let i = $index; let isFirst = $first) {
                  <ng-container
                    class="bidList__list">
                    <tr [attr.data-testid]="'common-list-results-row-' + $index" list-row-inventory-item class="shared-list-row-inventory-item"
                      [isListView]="isListView" [bidlistMultiRemoveLimit]="BIDLIST_MULTI_REMOVE_LIMIT"
                      [currentPage]="bidlist.pagination.page" [bidItem]="item" variant="result"
                      [dealershipCollection]="dealershipCollectionWithProfile" [dealershipFinanceMap]="dealershipFinanceMap"
                      [buyerTipEnabled]="buyerTipEnabled" [userPreferences]="userProfile?.userPreferences"
                      [financeSources]="financeSources" [tenantName]="tenantName" [urlBase]="urlBase"
                      [urlBaseExternal]="urlBaseExternal" [index]="i"
                      [isSharedListVehicleSelected]="isSharedListVehicleToggled(item.auctionItemUuid)" [paginatedSharedList$]="bidList$"
                      [isBidListVehicleSelected]="isBidListVehicleToggled(item.auctionItemUuid)" [paginatedBidList$]="bidList$"
                      [isVehicleSelected]="isVehicleToggled(item.auctionItemUuid)"
                      [bidListMultiSelectEnabled]="bidListMultiSelectEnabled"
                      [bidlistInventoryItemTranslations]="bidlistInventoryItemTranslations"
                      [platformSpareKeyFee]="bidlist.pagination.metaData?.platformSpareKeyFee"
                      (onReviewSelectAllNeeded)="evaluateSelectAllCheckbox()"
                      (bidItemUpdated)="bidlist.items[i]= $event"
                    [hide]="hasBeenRemoved(item.auctionItemUuid)"></tr>
                  </ng-container>
                }
              </table>
            }
            <div class="legacy-button-container">
              @if (isLegacyBidlistLinkEnabled) {
                <button data-testid="common-list-results-legacy-button" id="auction_info_redirect_to_legacy_bidlist" class="btn btn-link" type="button"
                  (click)="redirectToLegacyBidlist()" data-track-elem="button" data-track-name="Back to Legacy Bid List"
                  data-track-trigger="button" [attr.aria-label]="convert('vehicles.bidList.ariaLabelLegacyBid')">
                  {{ convert('vehicles.bidList.ariaLabelLegacyBid') }}
                </button>
              }
            </div>
          } @else {
            @if (!isSharedList) {
              <app-error-message data-testid="common-list-results-empty-state"
                [title]="bidlistTranslations.titleBidListEmpty"
                [subtitle]="bidlistTranslations.subTitleVehicle"></app-error-message>
            } @else if(isCustomOffer) {
              <app-error-message data-testid="common-list-results-custom-offer-empty-state"
                [title]="bidlistTranslations.titleCustomOfferEmpty"
                [subtitle]="bidlistTranslations.subTitleVehicleSharedList"></app-error-message>
            } @else if (isSharedList) {
              <app-error-message data-testid="common-list-results-shared-list-empty-state"
                [title]="bidlistTranslations.titleSharedListEmpty"
                [subtitle]="bidlistTranslations.subTitleVehicleSharedList"></app-error-message>
            }
          }
        }
      }
      @if (bidlist.pagination) {
        <app-pagination data-testid="common-list-results-pagination" [totalCount]="bidlist.pagination.totalItems"
          [perPage]="bidlist.pagination.itemsPerPage" [maxPages]="7" [currentPage]="bidlist.pagination.page"
          [hidePerPage]="false" (pageChanged)="changePage($event)" (perPageChanged)="changePerPage($event)"
        [pagination]="translatedObject"></app-pagination>
      }
    }
  </div>


  <ng-template #loader>
    <div class="grid loader-card d-flex flex-row justify-content-center align-items-center">
      <!-- Vehicle Image -->
      <div class="grid-left col-5">
        <div class="animated-background"></div>

        <div class="image">
          <svg viewBox="0 0 521.1 310.9">
            <style>
              .st0 {
              fill: #eee;
            }
          </style>
          <path
            d="M521 136.6c-.1-.6-1.2-13.8-1.9-18.9-.3-2.3-.3-7.7-.2-12.9.1-6.3.1-12.3-.4-15-.7-3.6-3.8-8.3-6.5-12.4-1-1.5-2-3-2.6-4.1-1.2-2.2-3-4.3-4.9-6.5-1.8-2.1-3.7-4.4-5.5-7l-22.9-35-.1-.1c-.4-.5-9.1-11.4-49.7-19.8C386.2-3.5 273.4 1 268.7 1.2c-1.9 0-46.2-.2-76.7 13.4-18.6 8.3-41.9 26.1-57.5 38.9-7.3.1-11.2 2.5-13.5 4-1.8 1.1-1.7 5.8-1.5 8.8-1.3 1.2-2.1 1.9-2.4 2.1l-3.5 3.3c-4.5 1.3-27.9 8-30.7 9.1-2.1.9-7.6 1.4-10.9 1.8-.7.1-1.4.1-1.9.2-4.1.4-23.9 5-39.6 17.6-16.1 12.9-26.4 45.7-27.8 53.8-7.4 41 7.3 90.3 10.3 97.6.5 1.3 1 2.4 22.3 4.6 2.3 2.6 5.5 5.4 9.9 7.7-6.8.8-42.2 5.2-45.2 12.9-3.3 8.5 126.5 39.8 204.5 32.9 69.3-6.1 104.2-14.8 111.1-16.6 1.5-.1 3-.2 4.6-.3 18.5-1.8 29.9-11.9 36.8-23.9l136.4-39.9c9.4-.3 15.8-1.8 21.3-16.5 0 0 4.2-11.1 5.2-32.1.5-10.9 1.1-29-.9-43.7l2-.3zm-163.4 97.2c-3.1 35.6-24.7 43.9-32.7 44.1-15.8.3-27.1-14.8-31-41.6-.2-1.7-.4-3.3-.5-5 1.6-12.6 4.4-27.5 9.3-41.7.1-.1.2-.3.4-.5 6.9-10.8 14.6-16.1 22.8-15.9 6.1.2 12.5 3.6 17.9 9.7 10.4 11.5 15.5 30.6 13.8 50.9zm156.5-49.3c-1 31.6-11.9 33-12 33h-.3c-1.6 0-3.6 0-5.6-2-2.8-3-6-11-4.9-32.4 1.1-22.3 5.6-34.6 12.6-34.6.3 0 1.8.1 3.6 2 2.8 2.8 7.3 11 6.6 34zm-9.2-71.4s-.1 0 0 0c-10.5.4-18.5 14.4-23.9 41.4-3.3 16.5-4.6 33.1-4.9 37.9L371 223.7c-.4-9-2.1-38.4-8.9-54.1-7.2-20.6-27-20.3-28.4-20.3-1.2 0-17.7.6-29.3 25.3-14.1 30.1-16.7 67.6-17.1 82.2 0 0-.3.7-2.6 1.5-13.6 5-65.7 5.7-142.9 1.9-62.8-3.1-118.6-8.1-125.3-10.4-2-5.9-17.3-53.5-9.9-94.8.2-1.1.6-2.6 1.1-4.6 10.6 6.7 20 9.9 52.7 13.6 2.6 14.6 32.8 14.8 49.2 15.3 16.4.5 36.8 1.9 42.2-8.8 37.1 0 74-3.4 101.1-11.5 27.3-8.2 31.2-18.6 35.2-39.1C235.5 134.8 63 146.3 23.9 114c2.8-4.1 5.8-7.7 9.1-10.4 15-12 33.7-16.3 37.5-16.8.5-.1 1.2-.1 1.9-.2 3.9-.4 9.4-.9 12-2 2.3-.9 23-6.9 30.7-9.1l.5-.1 4.1-3.9c.3-.3 22.9-20.7 46.5-37.1-5.7 4.1-11.1 8.4-16.1 12.5-1.6 1.2-2.9 2.3-3.9 3.2-.7.6-1.6 1.4-2.7 2.3-4.4 3.7-8.2 7.1-11.2 9.8-6.4 5.7-12.3 11-12.3 11s-5.5 4.4-.6 5.4c10.3 2.2 25.7 1.1 25.7 1.1s110.2 2.3 127.4 2.1 43.9-2 50.3-2.7c6.4-.7 14.3-2.3 19.5-12s15.2-27.9 19.9-36.3c4.7-8.4 11.2-18.3 11.2-18.3S313 8.9 269.5 10.4c-25.5.9-43.3 2-53.6 2.8l-9 .4c28.2-8.4 61.5-8.2 62-8.2C270.1 5.4 386 .7 425.6 9c37.5 7.8 46.8 17.7 47.3 18.3l22.9 34.9c1.9 2.9 3.9 5.3 5.8 7.4 1.8 2.1 3.4 4 4.5 5.8.7 1.2 1.7 2.7 2.8 4.3 2.4 3.6 5.4 8.1 5.9 10.9.4 2.2.4 8.6.3 14.2 0 5.6-.1 10.8.2 13.4.1.4.1.9.2 1.4-4.1-6.4-10.2-6.5-10.6-6.5z"
            class="st0" />
          <path
            d="M472.2 28.7c-.5-.6-1.3-1.2-2.2-1.8-3.1-2.6-7.3-3.8-7.3-3.8-12.3-5.3-32.1-8.5-32.1-8.5-9.5-1.5-27-3.1-35.6-1.8S379 22 376.4 26c-2.6 4-17.5 33-17.5 33-4.8 9.2-3.4 26.2-3.4 26.2v2.7l14-.5.5-2.2s5.6.1 38.8-2.1c4.1-.3 6-2.5 6.8-3.8.3 0 31-3.6 39.2-4.6 8.7-1.1 12.6-5 14.5-6.9l.2-.2c1.2-1.2 4.5-6.5 10.1-15.8.9-1.5 1.8-3 2.2-3.6l.2-.2c1.3-2 .1-5.2-.7-6.9l-9.1-12.4z"
            class="st0" />
        </svg>
      </div>
    </div>

    <!-- Information -->
    <div class="grid-right col-8">
      <div class="animated-background"></div>

      <div class="loading item"></div>
      <div class="loading item" style="width: 85%"></div>
      <div class="loading item"></div>
      <div class="loading item" style="width: 85%"></div>
    </div>
  </div>
</ng-template>
</ng-container>
<app-error-modal data-testid="common-list-actions-error-modal"></app-error-modal>
@if (isSharedList) {
  <app-shared-list-action-bar data-testid="common-list-actions-shared-action-bar"
    (onActionSelected)="showMultiActionModal($event)"
    [isCommonMultiCheckboxImplementationEnabled]="commonMultiCheckboxImplementationEnabled"
    [declineEnabled]="isDeclineEnabled">
  </app-shared-list-action-bar>
}
<app-shared-list-multi-action-modal data-testid="common-list-actions-multi-action-modal" [userType]="userType" (modalEvent)="createBanners($event)"></app-shared-list-multi-action-modal>
@if (!isSharedList) {
  <app-bidlist-action-bar data-testid="common-list-actions-bidlist-action-bar"
    (onActionSelected)="bidListMultiRemoveSubmit($event)"
    [isCommonMultiCheckboxImplementationEnabled]="commonMultiCheckboxImplementationEnabled">
  </app-bidlist-action-bar>
}
<app-action-submitting-modal data-testid="common-list-actions-submitting-modal" [actionText]="textBidListMultiRemoveSubmittingTranslation"></app-action-submitting-modal>
<ng-template appModalPortal></ng-template>
